import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    item: {
      fontWeight: 'bold',
      display: 'block',
      marginRight: 5,
      fontSize: theme.typography.pxToRem(13),
      textTransform: 'capitalize',
    },
    value: {
      fontSize: theme.typography.pxToRem(13),
    },
  };
});

export { useStyles };
